import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import libUrl from 'url';
import _ from 'lodash';
import Root from './root';

ReactDOM.render(<Root />, document.getElementById('root'));	

registerServiceWorker();

document.addEventListener('DOMContentLoaded', () => {
	window.Raven
		.config('https://134e3bb163e4462c8a9161c28822e48e@sentry.io/1237640').install();
})


// WEBPACK FOOTER //
// ./src/index.js